var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6037 12.0158C9.25221 13.0115 7.57439 13.4598 5.9064 13.2707C4.23841 13.0816 2.70346 12.2692 1.60904 10.9963C0.514622 9.72331 -0.0584208 8.08379 0.00471316 6.40617C0.0678471 4.72856 0.762495 3.13675 1.94949 1.94965C3.13649 0.762558 4.72816 0.0678528 6.40564 0.00471356C8.08312 -0.0584256 9.72251 0.514665 10.9954 1.60917C12.2682 2.70368 13.0805 4.23877 13.2696 5.90689C13.4586 7.57502 13.0104 9.25298 12.0148 10.6046L15.6822 14.271C15.7803 14.3624 15.859 14.4727 15.9136 14.5951C15.9681 14.7176 15.9975 14.8498 15.9998 14.9839C16.0022 15.118 15.9776 15.2511 15.9273 15.3755C15.8771 15.4998 15.8024 15.6127 15.7076 15.7076C15.6128 15.8024 15.4998 15.8771 15.3755 15.9273C15.2512 15.9775 15.118 16.0022 14.984 15.9998C14.8499 15.9975 14.7177 15.9681 14.5953 15.9136C14.4728 15.859 14.3626 15.7803 14.2712 15.6822L10.6037 12.0158ZM11.3159 6.65597C11.3159 7.89176 10.825 9.07694 9.95128 9.95078C9.07751 10.8246 7.89244 11.3155 6.65674 11.3155C5.42105 11.3155 4.23598 10.8246 3.36221 9.95078C2.48845 9.07694 1.99757 7.89176 1.99757 6.65597C1.99757 5.42017 2.48845 4.235 3.36221 3.36116C4.23598 2.48732 5.42105 1.9964 6.65674 1.9964C7.89244 1.9964 9.07751 2.48732 9.95128 3.36116C10.825 4.235 11.3159 5.42017 11.3159 6.65597Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c96f174ef97f0da3b4e6b7cee0edd146.svg";
export { ForwardRef as ReactComponent };